import { connect } from 'react-redux';
import Credenciais from './credenciais';

export default connect()(Credenciais);
